
// Pluggable export registry. Every digitization tool shares this single
// pipeline: Digitization Tool -> Feature Model -> Export Engine -> file.
// Exporters register themselves (see GeoJSONFeatureExporter.js etc.) instead
// of the UI hard-coding a fixed format list.

const exporters = [];

export const ExportRegistry = {
	register(exporter){
		if(exporters.find(e => e.id === exporter.id)) return;
		exporters.push(exporter);
	},
	list(){
		return exporters.slice();
	},
	get(id){
		return exporters.find(e => e.id === id);
	},
};
